/* tslint:disable */
// Expected code is LanguageItemCache.Items[LangID].Code
// Note: this helper is meant to retrieve the necessary localization code for queries to the SportsData API
// Currently the API supports only two digit codes - upon adding support for diffetent standarts additional mapping/refactor is needed
export function getLanguageCodeInQueryFormat(code) {
    const defaultLanguage = "en";
    let result = "";
    let i = 0;
    if (code === undefined || code.length < 2) {
        return defaultLanguage;
    }
    while (result.length < 2 && i < code.length) {
        if (code.charAt(i) && code.charAt(i).match(/^[a-zA-Z)]+$/)) {
            result += code.charAt(i);
        }
        i += 1;
    }
    return (result.length === 2) ? result : defaultLanguage;
}
//# sourceMappingURL=LanguageHelper.js.map